




















import {Component, Vue} from "vue-property-decorator";
import {State} from "vuex-class";
import { VideoCategoryInterface } from "@/models/video";

@Component
export default class MusicalPractica extends Vue {
    @State(state => state.video.musicalCategories) categories: VideoCategoryInterface[];

}
